import script from "./VButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VButton.vue?vue&type=script&setup=true&lang=ts"

import "./VButton.vue?vue&type=style&index=0&id=e45f9436&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e45f9436"]])

export default __exports__